import React, { Component } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";
import avatar2 from '../../assets/images/users/avatar-2.jpg';

class ProfileMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            menu: false,
            userData: null // Store the entire user object
        };
        this.toggle = this.toggle.bind(this);
    }

    componentDidMount() {
        this.getUserId();
    }

    getUserId() {
        const userData = JSON.parse(localStorage.getItem("user"));
        console.log("userData", userData);
        this.setState({ userData });
        // if (user) {
        //     console.log("trying to parse user data");
        //     try {
        //         const userData = JSON.parse(user);
        //         console.log(userData);
        //         this.setState({ userData });
        //     } catch (e) {
        //         console.error("Failed to parse user data:", e);
        //     }
        // } else {
        //     console.log("No user data found");
        // }
    }

    toggle() {
        this.setState(prevState => ({
            menu: !prevState.menu
        }));
    }

    render() {
        const { userData } = this.state;
        const { t } = this.props;
        
        // Default values if no user data
        const username = userData?.name || "staff" || "admin";
        const userId = userData?.id || null;
        const profileImage = userData?.profile_picture || avatar2;

        return (
            <React.Fragment>
                <Dropdown 
                    isOpen={this.state.menu} 
                    toggle={this.toggle} 
                    className="d-inline-block user-dropdown"
                >
                    <DropdownToggle 
                        tag="button" 
                        className="btn header-item waves-effect" 
                        id="page-header-user-dropdown"
                    >
                        <img 
                            className="rounded-circle header-profile-user me-1" 
                            src={profileImage} 
                            alt="Header Avatar" 
                        />
                        <span className="d-none d-xl-inline-block ms-1 text-transform">
                            {username}
                        </span>
                        <i className="mdi mdi-chevron-down d-none ms-1 d-xl-inline-block"></i>
                    </DropdownToggle>
                    
                    <DropdownMenu className="dropdown-menu-end">
                        <DropdownItem tag={Link} to="/staff/profile">
                            <i className="ri-user-line align-middle me-1"></i> {t('Profile')}
                        </DropdownItem>
                        
                        {/* Portfolio Link - Only show if userId exists */}
                        {userId && (
                            <DropdownItem 
                                tag={Link} 
                                to={`/admin/office/staff-portfolio/${userId}`}
                            >
                                <i className="mdi mdi-folder-account align-middle me-1"></i> 
                                {t('Portfolio')}
                            </DropdownItem>
                        )}
                        
                        <DropdownItem tag={Link} to="#">
                            <span className="badge badge-success float-end mt-1">11</span>
                            <i className="ri-settings-2-line align-middle me-1"></i> {t('Settings')}
                        </DropdownItem>
                        
                        <DropdownItem tag={Link} to="#">
                            <i className="ri-lock-unlock-line align-middle me-1"></i> {t('Lock screen')}
                        </DropdownItem>
                        
                        <DropdownItem divider />
                        
                        <DropdownItem tag={Link} to="/logout" className="text-danger">
                            <i className="ri-shut-down-line align-middle me-1 text-danger"></i> 
                            {t('Logout')}
                        </DropdownItem>
                    </DropdownMenu>
                </Dropdown>
            </React.Fragment>
        );
    }
}

export default withTranslation()(ProfileMenu);